import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Footer from "../components/Footer";
import "../static/css/PrivacyPolicy.css"; // Reusing the same styling

const TermsAndConditions = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleBack = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate("/");
        }
    };

    return (
        <div className="privacy-policy-wrapper">
            <div className="privacy-policy-header-bar">
                <button className="back-button" onClick={handleBack}>
                    <FaArrowLeft /> <span>Back</span>
                </button>
            </div>
            <div className="privacy-policy-container">
                <h1>Terms and Conditions</h1>

                <section className="privacy-policy-section">
                    <p>Please read these terms and conditions ("terms and conditions", "terms") carefully before using <a href="http://www.skpandco.in">www.skpandco.in</a> website (“website”, "service") operated by SKP and Co ("us", 'we', "our").</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>Conditions of use</h2>
                    <p>By using this website, you certify that you have read and reviewed this Agreement and that you agree to comply with its terms. If you do not want to be bound by the terms of this Agreement, you are advised to stop using the website accordingly. SKP and Co only grants use and access of this website, its products, and its services to those who have accepted its terms.</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>Privacy policy</h2>
                    <p>Before you continue using our website, we advise you to read our <Link to="/privacy-policy">privacy policy</Link> regarding our user data collection. It will help you better understand our practices.</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>Intellectual property</h2>
                    <p>You agree that all materials, products, and services provided on this website are the property of SKP and Co, its affiliates, directors, officers, employees, agents, suppliers, or licensors including all copyrights, trade secrets, trademarks, patents, and other intellectual property. You also agree that you will not reproduce or redistribute the SKP and Co's intellectual property in any way, including electronic, digital, or new trademark registrations.</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>User accounts</h2>
                    <p>As a user of this website, you may be asked to register with us and provide private information. You are responsible for ensuring the accuracy of this information, and you are responsible for maintaining the safety and security of your identifying information. You are also responsible for all activities that occur under your account or password.</p>
                    <p>If you think there are any possible issues regarding the security of your account on the website, inform us immediately so we may address them accordingly.</p>
                    <p>We reserve all rights to terminate accounts, edit or remove content and cancel orders at our sole discretion.</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>Applicable law</h2>
                    <p>By using this website, you agree that the laws of the India, without regard to principles of conflict laws, will govern these terms and conditions, or any dispute of any sort that might come between SKP and Co and you, or its business partners and associates.</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>Indemnification</h2>
                    <p>You agree to indemnify SKP and Co and its affiliates and hold SKP and Co harmless against legal claims and demands that may arise from your use or misuse of our services. We reserve the right to select our own legal guidance.</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>Limitation on liability</h2>
                    <p>SKP and Co is not liable for any damages that may occur to you as a result of your misuse of our website.</p>
                    <p>SKP and Co reserves the right to edit, modify, and change this Agreement at any time. We shall let our users know of these changes through electronic mail or a Notification in the website. This Agreement is an understanding between SKP and Co and the user, and this supersedes and replaces all prior agreements regarding the use of this website.</p>
                </section>

                <section className="privacy-policy-section">
                    <h2>Disputes</h2>
                    <p>Any dispute related in any way to your use of this website or to products you purchase from us shall be settled by way of arbitration in Coimbatore and you consent to exclusive jurisdiction and venue of such courts.</p>
                </section>

                <div className="privacy-policy-footer">
                    <p>© 2024 SKP and Co. All rights reserved.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TermsAndConditions;
